export default __webpack_public_path__ + "static/media/roadmap_1.b4c4fb94.png";